import { I18nProvider, RouterProvider, ToastProvider } from "@heroui/react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useHref, useNavigate } from "react-router";
import i18n from "src/general/localization/i18n";
import { useTheme } from "src/hooks/useTheme";
import { resolveInitialTheme } from "src/utils/commonUtils";

export function RootLayout() {
  const [isMounted, setIsMounted] = useState(false);
  const { setTheme } = useTheme();
  const { i18n: activeI18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isMounted) {
      // Handle initial language and theme setup for all users
      const storedLanguage = window.localStorage.getItem("language");
      if (storedLanguage) {
        i18n.changeLanguage(storedLanguage);
      }
      setTheme(resolveInitialTheme());
      setIsMounted(true);
    }
  }, [isMounted, setTheme]);

  if (!isMounted) {
    return null;
  }

  // I18nProvider feeds the app language to v3's locale-aware inputs (date,
  // number, time); RouterProvider connects v3 React Aria links to React
  // Router for client-side nav.
  return (
    <I18nProvider locale={activeI18n.language}>
      <RouterProvider navigate={navigate} useHref={useHref}>
        <ToastProvider placement="top" />
        <Outlet />
      </RouterProvider>
    </I18nProvider>
  );
}
